import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextBrackets32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconTextBrackets32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 10.25A4.25 4.25 0 0 1 7.25 6H9a1 1 0 0 1 0 2H7.25A2.25 2.25 0 0 0 5 10.25v11.5A2.25 2.25 0 0 0 7.25 24H9a1 1 0 1 1 0 2H7.25A4.25 4.25 0 0 1 3 21.75zm26 0A4.25 4.25 0 0 0 24.75 6H23a1 1 0 1 0 0 2h1.75A2.25 2.25 0 0 1 27 10.25v11.5A2.25 2.25 0 0 1 24.75 24H23a1 1 0 1 0 0 2h1.75A4.25 4.25 0 0 0 29 21.75zM10.5 11a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2h-11a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextBrackets32);
